/// <reference path="./global.d.ts" />
/*!
 * @preserve
 * TracerouteClient.js
 * TracerouteClient Frontend JS for dein-ip-check.de
 *
 * @version 3.0
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

// Ping-Client Library laden
//import "./lib/library";
import "./updateview";
import generateTracerouteHop, {errorCode, generateEmptyHop} from "./updateview";

// Validate IPv4/6
const isIp = require('is-ip');
const isDomain = require('is-valid-domain');

window.onload = () => {
    //
    // benötigte Variablen instanzieren
    //
    let domTracerouteStart = $("#tracerouteStart"),
        domTracerouteStop  = $("#tracerouteStop"),
        zielIp: string = undefined,
        protokoll: string = undefined,
        lasthop: number = undefined,
        traceroute: object[] = [],
        websocket: WebSocket;

    // Feststellen ob String im Json Format ist
    const isJson = (jsonString:string): boolean =>
    { let isValidJSON = true; try { JSON.parse(jsonString) } catch { isValidJSON = false } return isValidJSON; };
        
    /**
     * Traceroute-Vorgang starten
     */
    domTracerouteStart.on("click", function (event: JQuery.Event) {
        // Prevent Default Action / detect disabeld Button
        event.preventDefault();

        // Traceroute-Array leeren
        traceroute = [];
        lasthop = undefined;

        // Start-Button sperren / Stop-Button entsperren
        domTracerouteStart.removeClass("active").addClass("disabled");
        domTracerouteStop.removeClass("disabled").addClass("active");
        $("#tracerouteError").addClass("hidden");
        $("#tracerouteActiveText").removeClass("hidden");
        
        // Ziel-IP/Hostname ermitteln
        zielIp = String($("#ipadresse").val());
        protokoll = String($("#protokoll").val());
        
        if(!isDomain(zielIp)) {
            if (!isIp(zielIp)) {
                displayErrorMessage(TRACEROUTESTRINGS["Ungültige IPv4/IPv6-Adresse oder Hostname angegeben"]);
                return;
            }

            // Protokoll ermitteln
            if (protokoll !== "4" && protokoll !== "6") {
                displayErrorMessage(TRACEROUTESTRINGS["Ungültiges Protokoll angegeben"]);
                return;
            }
            
            // Prüfe auf richtiges Protokoll bei einer IP-Adresse
            if (isIp.v6(zielIp) && protokoll !== '6') {
                displayErrorMessage(TRACEROUTESTRINGS["Ungültiges Protokoll angegeben"]);
                return;
            } else if (isIp.v4(zielIp) && protokoll !== '4') {
                displayErrorMessage(TRACEROUTESTRINGS["Ungültiges Protokoll angegeben"]);
                return;
            }
        }
        
        // Websocket abhängig vom gewählten Ziel starten
        let messtation: string;
        let chartProtokollHTMLElement = $("#messureServer");
        if (chartProtokollHTMLElement.val() == "dus") {
            messtation = "wss://de-dus.ping.dein-ip-check.de/api/";
        } else if (chartProtokollHTMLElement.val() == "nue") {
            messtation = "wss://de-nue.ping.dein-ip-check.de/api/";
        } else if (chartProtokollHTMLElement.val() == "brl") {
            messtation = "wss://de-brl.ping.dein-ip-check.de/api/";
        } else if (chartProtokollHTMLElement.val() == "ffm") {
            messtation = "wss://de-ffm.ping.dein-ip-check.de/api/";
        } else {
            displayErrorMessage(TRACEROUTESTRINGS["Fehler mit der Verbindung zur Messstation"] + "- 2");
            return;
        }
        
        // Websocket-Verbindung aufbauen
        websocket = new WebSocket(messtation);
        websocket.onopen = function () {
            websocket.send(`traceroute|${zielIp}|${protokoll}|${TRACEROUTELANGUAGE.toLowerCase()}`);
        };

        // Callback: Websocket Fehler
        websocket.onerror = function () {
            displayErrorMessage(TRACEROUTESTRINGS["Fehler bei der Websocket-Verbindung"] + "(" + websocket.readyState + ")");
        };

        // Callback Funktion: Websocket erhält eine Nachricht
        websocket.onmessage = function (evt: MessageEvent) {
            let response = JSON.parse(evt.data);
            
            // Prüfe Server-Antwort auf Fehlermeldungen
            if(typeof response.message === 'number' && response.message < 0) {
                displayErrorMessage(
                    TRACEROUTESTRINGS[ errorCode[String(response.message)] ]  
                );
                return;
            }

            // JSON Message Feld bei Bedarf umwandeln in Objekt
            if((response.status === "ok" && isJson(response.message))) {
                // übermittelter HOP in Array speichern
                response.message = JSON.parse(response.message);
                traceroute[parseInt(response.message.hop)] = response.message;
            } else if(response.status === "CLOSE") {
                // Die übermittelte Anzahl der HOPs zum Erkennen des Traceroute-Abschluss hinterlegen
                lasthop = parseInt(response.message);
            }

            // Prüfe ob letzter HOP bereits erreicht wurde
            let hopmissing:boolean = false;
            if(lasthop !== undefined) {
                // Prüfe ob alle HOP erfolgreich ermittelt wurden
                // HOP 1 wegen Bug im Traceroute-Tool des Servers ausgelassen
                for (let i = 2; i <= lasthop; i++) {
                    if(traceroute[i] === undefined) {
                        hopmissing = true;
                    }
                }
            }
            
            // Prüfe ob alle HOP ermittelt wurden
            if(hopmissing !== true && lasthop !== undefined) {
                // Setze Buttons zurück
                $(domTracerouteStart).removeClass("disabled").addClass("active");
                $(domTracerouteStop).removeClass("active").addClass("disabled");
                $("#tracerouteActiveText").addClass("hidden");
                
                // Bei keinen HOP Fehlermeldung ausgeben
                if(traceroute.length <= 0 && lasthop <= 0) {
                    displayErrorMessage(TRACEROUTESTRINGS['Traceroute fehlgeschlagen - Hostname nicht auflösbar oder IP nicht erreichbar?']);
                    return;
                } else {
                    // Verbindung normal schließen
                    websocket.close();
                }
            }
            
            // Bisher ermittelte Traceroute-HOPs ausgeben
            let tracerouteOutput: string = ""
            for (let index = 1; index <= traceroute.length-1; index++) {
                let hop:any = traceroute[index];
                if(hop !== undefined) {
                    // Ergebnis-Tabelle freigeben
                    $("#tracerouteResultText").removeClass('hidden');

                    // Land ggf. übersetzen
                    if(hop.geoinfo.country === "world") {
                        hop.geoinfo.country = TRACEROUTESTRINGS['world'];
                    }

                    // Ausgabe zusammenstellen
                    tracerouteOutput = tracerouteOutput + generateTracerouteHop(
                        index.toString(),
                        hop.hostname,
                        hop.ip,
                        hop.geoinfo.country,
                        hop.geoinfo.isp,
                        hop.rtt1,
                        hop.geoinfo.countrycode.toLowerCase(),
                    )
                } else {
                    if(index === 1 && traceroute.length > 1) {
                        // Workaround für lokale IPs, die nicht beim HOP1 übermittelt werden / trifft nur auf Yamato zu
                        tracerouteOutput = tracerouteOutput + generateTracerouteHop(
                            index.toString(),
                            "yamato.tf-network.de",
                            "2001:4ba0:ffa0:1b::221",
                            (TRACEROUTELANGUAGE === "de" ? "Deutschland" : "Germany"),
                            "myLoc managed IT AG",
                            "0",
                            "de"
                        );
                    } else {
                        // Leerer HOP generieren
                        tracerouteOutput = tracerouteOutput + generateEmptyHop();
                    }
                }
            }
            
            $("#tracerouteHop").html(tracerouteOutput);
        };
    });  

    /**
     * Traceroute-Vorgang beenden
     */
    domTracerouteStop.on("click", function (event: JQuery.Event) {
        // Prevent Default Action / detect disabeld Button
        event.preventDefault();
        if ($(this).hasClass("disabled")) {
            return false;
        }
        
        // Websocket-Verbindung schließen
        if(typeof websocket === 'object') {
            websocket.close();
        }
        
        traceroute = [];
        
        // Setze Buttons zurück
        $(domTracerouteStart).removeClass("disabled").addClass("active");
        $(domTracerouteStop).removeClass("active").addClass("disabled");
        $("#tracerouteError").addClass("hidden");
        $("#tracerouteActiveText").addClass("hidden");
    });

    /*
     * Error-Ausgabe
     */
    function displayErrorMessage(errorMsg: string) {
        console.error(errorMsg);
        
        $("#tracerouteErrorText").text(errorMsg);
        $("#tracerouteError").removeClass("hidden");
        $("#tracerouteResultText").addClass('hidden');
        $("#tracerouteActiveText").addClass("hidden");

        // Setze Buttons zurück
        $(domTracerouteStart).removeClass("disabled").addClass("active");
        $(domTracerouteStop).removeClass("active").addClass("disabled");
    }

};
